import { useState, useCallback } from 'react';

import { api } from '@/services';
import { getErrorDetails } from '@/utils';

const useConversionHistory = ({ onUnauthorized }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const resetState = () => {
    setIsLoading(false);
    setError(null);
    setData(null);
  };

  const getHistory = useCallback(async (page = 1, filters = {}) => {
    resetState();

    setIsLoading(true);

    try {
      setData(await api.getConversionHistory(page, 10, filters));
    } catch (err) {
      const { is401, is500, message } = getErrorDetails(err);

      if (is401) {
        onUnauthorized();
      } else if (is500) {
        setError(`'Failed to load conversion history. Refresh the page.`);
      } else {
        setError(message);
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { data, error, isLoading, getHistory };
};

export default useConversionHistory;
